import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import users from "./slices/usersSlice";
import nannies from "./slices/nannySlice";
import parents from "./slices/parentSlice";
import partners from "./slices/partnerSlice";
import jobs from "./slices/jobSlice";
import account from "./slices/accountSlice";
import dashboards from "./slices/DashBoardsSlice";
import tasks from "./slices/tasksSlice";
import appointments from "./slices/AppointmentSlice";
import application from "./slices/applicationSlice";
import reports from "./slices/reportSlice";
import plans from "./slices/planSlice";


const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    users,
    nannies,
    parents,
    jobs,
    account,
    dashboards,
    appointments,
    tasks,
    application,
    reports,
    partners,
    plans,

    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
